import { IGoodReceive } from '@/interfaces/goodReceive';
import { formatThaiDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  data?: IGoodReceive;
}

const TemplateReceiveOrderInfo = ({ data }: IProps) => {
  return (
    <>
      <div className="flex flex-row mt-4 mb-2">
        <div className="basis-2/3 gap-1 flex flex-col">
          <p className="text-sm">
            <span className="font-bold">รับจาก :</span>{' '}
            {data?.inbound?.consName}
          </p>
        </div>
        <div className="basis-1/3 gap-1 flex flex-col">
          <p className="text-sm">
            <span className="font-bold">เลขที่ใบเราสินค้า :</span>{' '}
            {data?.code || ''}
          </p>
          <p className="text-sm">
            <span className="font-bold">Invoice No. :</span>{' '}
            {data?.inbound?.invNO || ''}
          </p>
          <p className="text-sm">
            <span className="font-bold">Invoice Date :</span>{' '}
            {data?.inbound?.invDate && formatThaiDate(data?.inbound?.invDate)}
          </p>
        </div>
      </div>
    </>
  );
};

export default TemplateReceiveOrderInfo;
